import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'

interface AuthModalContextType {
  isOpen: boolean
  view: 'signin' | 'signup'
  openAuthModal: (view?: 'signin' | 'signup') => void
  closeAuthModal: () => void
  setIsPaused: (paused: boolean) => void
  isPaused: boolean
}

const AuthModalContext = createContext<AuthModalContextType | null>(null)

export function AuthModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [view, setView] = useState<'signin' | 'signup'>('signin')
  const [isPaused, setIsPaused] = useState(false)

  const openAuthModal = useCallback((initialView: 'signin' | 'signup' = 'signin') => {
    setView(initialView)
    setIsOpen(true)
  }, [])

  const closeAuthModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <AuthModalContext.Provider
      value={{
        isOpen,
        view,
        openAuthModal,
        closeAuthModal,
        isPaused,
        setIsPaused,
      }}
    >
      {children}
    </AuthModalContext.Provider>
  )
}

export function useAuthModal() {
  const context = useContext(AuthModalContext)
  if (!context) {
    throw new Error('useAuthModal must be used within AuthModalProvider')
  }
  return context
}
